import { useQuery } from '@tanstack/react-query';
import { getBookingDetailsQueryOptions } from '@/features/dashboard/bookings/hooks/useGetBookingDetails.ts';
import { BookingDetailsDto } from '@/features/dashboard/bookings/types/BookingDetailsDto.ts';
import { bookingDetailsMapper } from '@/features/dashboard/bookingChanges/types/BookingDetailsDto.mapper.ts';

/**
 * Karta „Stan rezerwacji” w panelu bocznym. Rezerwacja jest bytem samodzielnym,
 * więc kontrakt i zapytanie mieszkają w `features/dashboard/bookings`; tutaj
 * zostaje wyłącznie mapowanie na model widoku tego modułu, robione w `select`,
 * żeby komponent nie dotykał DTO.
 */
const useGetBookingSummary = (bookingId: string | undefined) =>
  useQuery({
    ...getBookingDetailsQueryOptions(bookingId),
    select: (dto: BookingDetailsDto) =>
      bookingDetailsMapper.toBookingSummary(dto),
  });

export default useGetBookingSummary;
